// Produits similaires : remplace le contenu de la section par celui que
// renvoie l'API de recommandations de Shopify.

class MxRecommandations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.chargee === 'true') return;
    this.charge();
  }

  async charge() {
    try {
      const rep = await fetch(this.dataset.url);
      if (!rep.ok) throw new Error(rep.status);

      const frais = new DOMParser().parseFromString(await rep.text(), 'text/html');
      const contenu = frais.querySelector('[data-recommandations]');

      // Sans produit recommande, la section reste vide et ne laisse
      // aucun titre orphelin.
      if (contenu && contenu.innerHTML.trim()) this.innerHTML = contenu.innerHTML;
    } catch (e) {
      console.error('Recommandations : chargement impossible', e);
    }
  }
}

customElements.define('mx-recommandations', MxRecommandations);
